import Vue from 'vue';
import TenantService from './tenant.service';
import { appKey } from '../helpers/appStorage';

const AUTH_TYPES = {
  COGNITO: 'cognito',
  SPRING: 'spring',
  OIDC: 'oidc',
};

export { AUTH_TYPES };

export default new Vue({
  data() {
    return {
      innerUserInfo: JSON.parse(localStorage.getItem(appKey('userInfo'))),
      innerSession: JSON.parse(localStorage.getItem(appKey('session'))),
      authType: localStorage.getItem(appKey('auth_type')),
    };
  },
  computed: {
    loggedIn() {
      return this.innerUserInfo != null;
    },
  },
  methods: {
    cognitoLogin(cognitoSession) {
      this.setAuthType(AUTH_TYPES.COGNITO);
      this.setSession(cognitoSession);
    },
    oidcLogin(loginResult) {
      this.setAuthType(AUTH_TYPES.OIDC);
      // Sama session-rakenne kuin Cognitolla: request-interceptor lukee idToken + accessTokenExpires
      this.setSession({
        idToken: loginResult.idToken,
        accessTokenExpires: loginResult.expiresOn,
        homeAccountId: loginResult.homeAccountId,
      });
    },
    springLogin() {
      this.setAuthType(AUTH_TYPES.SPRING);
      this.setSession(null);
    },
    setAuthType(authType) {
      localStorage.setItem(appKey('auth_type'), authType);
      this.authType = authType;
    },
    setSession(session) {
      localStorage.setItem(appKey('session'), JSON.stringify(session));
      this.innerSession = session;
    },
    getSession() {
      return this.innerSession;
    },
    setUserInfo(getMeResponse) {
      const currentTenant = TenantService.tenant;
      if (currentTenant == null || getMeResponse.tenants.findIndex(t => t.id === currentTenant) === -1) {
        if (getMeResponse.tenants.length > 0) {
          TenantService.setTenant(getMeResponse.tenants[0].id);
        } else {
          TenantService.clear();
        }
      }

      const userInfo = {};
      userInfo.tenantRoles = getMeResponse.tenantRoles;
      userInfo.roles = getMeResponse.roles;
      userInfo.firstName = getMeResponse.firstName;
      userInfo.lastName = getMeResponse.lastName;
      userInfo.username = getMeResponse.username;
      userInfo.phone = getMeResponse.phone;
      userInfo.agentUser = getMeResponse.agentUser;
      userInfo.enabled = getMeResponse.enabled;
      userInfo.subject = getMeResponse.subject;
      userInfo.id = getMeResponse.id;
      userInfo.imageKey = getMeResponse.imageKey;
      userInfo.email = getMeResponse.email;
      userInfo.tenants = getMeResponse.tenants;

      localStorage.setItem(appKey('userInfo'), JSON.stringify(userInfo));
      this.innerUserInfo = userInfo;
    },

    getUserInfo() {
      return this.innerUserInfo;
    },
    clearUserInfo() {
      localStorage.removeItem(appKey('userInfo'));
      localStorage.removeItem(appKey('session'));
      localStorage.removeItem(appKey('auth_type'));
      this.innerUserInfo = null;
      this.innerSession = null;
      this.authType = null;
    },
  },
});
